import gql from 'graphql-tag';
import { DISCUSSION_FRAGMENT, DISCUSSION_MESSAGE_FRAGMENT } from './fragment';

export const GET_DISCUSSIONS = gql`
  query Discussions($input: DiscussionsInput) {
    discussions(input: $input) @connection(key: "discussions") {
      totalCount
      discussions {
        ...DiscussionFragment
      }
    }
  }
  ${DISCUSSION_FRAGMENT}
`;

export const GET_DISCUSSION_MESSAGE = gql`
  query DiscussionMessages($input: DiscussionMessagesInput) {
    discussionMessages(input: $input) {
      totalCount
      messages {
        ...DiscussionMessageFragment
      }
    }
  }
  ${DISCUSSION_MESSAGE_FRAGMENT}
`;

export const GET_ALL_MESSAGE_UNSEEN = gql`
  query AllMessageUnseen($input: AllMessageUnseenInput) {
    allMessageUnseen(input: $input)
  }
`;
